/* Jeya Spices — perilaku toko.
 *
 * Semua yang di sini adalah penyempurnaan: halaman tetap bisa dipakai kalau berkas ini
 * gagal dimuat. Menu tetap tautan biasa, form pencarian tetap menuju /search, tombol
 * checkout tetap form POST, dan keranjang tetap tergambar dari Liquid.
 *
 * Perhitungan harga TIDAK dilakukan di sini. Setiap kali keranjang berubah, isinya
 * diminta ulang ke Shopify (Section Rendering API) supaya angka yang tampil selalu
 * angka resmi toko, bukan hasil hitungan ulang JavaScript.
 */
(function () {
  "use strict";

  var R = window.jeyaRoutes || {};
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------------------------------------------------------------- pemberitahuan */
  function toast(msg) {
    var box = $("#toasts");
    if (!box) return;
    var t = document.createElement("div");
    t.className = "toast";
    t.innerHTML = '<svg class="ic"><use href="#i-check"/></svg><span></span>';
    t.lastChild.textContent = msg;
    box.appendChild(t);
    setTimeout(function () {
      t.style.opacity = "0";
      t.style.transform = "translateY(10px)";
      setTimeout(function () { t.remove(); }, 320);
    }, 2600);
  }

  /* ---------------------------------------------------------------- overlay */
  var lastFocus = null;

  function lock(on) {
    document.body.style.overflow = on ? "hidden" : "";
  }

  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    $$(".drawer.open").forEach(function (d) {
      d.classList.remove("open");
      d.setAttribute("aria-hidden", "true");
    });
    el.classList.add("open");
    el.setAttribute("aria-hidden", "false");
    var scrim = $("#scrim");
    if (scrim) scrim.classList.add("on");
    lock(true);
    var f = el.querySelector("button,a,input");
    if (f) f.focus();
  }

  function closeAll() {
    var ov = $("#searchOv"), fil = $("#filters");
    var adaYangTerbuka = $(".drawer.open") ||
      (ov && ov.classList.contains("open")) ||
      (fil && fil.classList.contains("open"));

    $$(".drawer.open").forEach(function (d) {
      d.classList.remove("open");
      d.setAttribute("aria-hidden", "true");
    });
    var scrim = $("#scrim");
    if (scrim) scrim.classList.remove("on");
    if (ov) { ov.classList.remove("open"); ov.setAttribute("aria-hidden", "true"); }
    if (fil) fil.classList.remove("open");
    lock(false);

    /* kembalikan fokus ke tempat asalnya, bukan ke atas halaman */
    if (adaYangTerbuka && lastFocus && document.contains(lastFocus)) {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  function trapFocus(e) {
    if (e.key !== "Tab") return;
    var ov = $("#searchOv"), fil = $("#filters");
    var box = $(".drawer.open") ||
      (ov && ov.classList.contains("open") ? $(".search-card") : null) ||
      (fil && fil.classList.contains("open") ? fil : null);
    if (!box) return;
    var f = $$("a[href],button:not([disabled]),input,select,textarea", box)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------------------------------------------------------- keranjang */
  var sedangKirim = false;

  function segarkanKeranjang(bukaLaci) {
    return fetch(window.location.pathname + "?section_id=cart-drawer", { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");

        ["#cartBody", "#cartFoot"].forEach(function (sel) {
          var baru = doc.querySelector(sel), lama = $(sel);
          if (baru && lama) {
            lama.innerHTML = baru.innerHTML;
            lama.hidden = baru.hasAttribute("hidden");
          }
        });

        var hitung = doc.querySelector("#cartCountValue");
        var pil = $("#cartCount");
        if (hitung && pil) {
          var n = parseInt(hitung.textContent, 10) || 0;
          pil.textContent = n;
          pil.classList.toggle("zero", n === 0);
        }

        if (bukaLaci) openPanel($("#cart"));
      });
  }

  /* Widget aplikasi (bundle, upsell, dll.) menambah barang lewat permintaannya
     sendiri ke /cart/add — bukan lewat form produk tema. Dulu laci keranjang dan
     angka di ikon keranjang diam saja sampai halaman dimuat ulang, sehingga
     pelanggan mengira tombol bundle tidak bekerja lalu menekannya lagi.
     Sekarang setiap perubahan keranjang yang BUKAN dari tema ini (sedangKirim
     false) membuat laci digambar ulang; tambah barang juga membuka lacinya. */
  (function () {
    var POLA = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var tunda = null;
    function nanti(buka) {
      clearTimeout(tunda);
      tunda = setTimeout(function () { segarkanKeranjang(buka); }, 250);
    }
    var fetchAsli = window.fetch;
    if (fetchAsli) {
      window.fetch = function (input) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var luar = POLA.test(url) && !sedangKirim;
        var janji = fetchAsli.apply(this, arguments);
        if (luar) {
          janji.then(function (r) { if (r && r.ok) nanti(/\/cart\/add/.test(url)); })
               .catch(function () {});
        }
        return janji;
      };
    }
    var bukaAsli = XMLHttpRequest.prototype.open, kirimAsli = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (metode, url) {
      this.__jeyaUrl = String(url || "");
      return bukaAsli.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var x = this, url = x.__jeyaUrl || "";
      if (POLA.test(url) && !sedangKirim) {
        x.addEventListener("load", function () {
          if (x.status >= 200 && x.status < 300) nanti(/\/cart\/add/.test(url));
        });
      }
      return kirimAsli.apply(this, arguments);
    };
    /* Sebagian aplikasi memberi tahu tema lewat event, bukan lewat permintaan. */
    ["cart:refresh", "cart:updated", "cart:change", "cart:build"].forEach(function (n) {
      document.addEventListener(n, function () { nanti(false); });
    });
  })();

  /* ------------------------------------------------------------------ uang */
  /* Harga di keranjang tetap datang dari Shopify. Yang dihitung di sini hanya
     subtotal pratinjau di halaman produk, sebelum barang masuk keranjang, dan ia
     memakai format uang milik toko supaya lambangnya tidak ditebak. */
  function rapi(nilai, desimal, ribuan, koma) {
    var s = nilai.toFixed(desimal);
    var bagian = s.split(".");
    bagian[0] = bagian[0].replace(/\B(?=(\d{3})+(?!\d))/g, ribuan);
    return bagian.length > 1 ? bagian[0] + koma + bagian[1] : bagian[0];
  }

  function uang(sen) {
    var format = window.jeyaMoneyFormat || "${{amount}}";
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, jenis) {
      var v = sen / 100;
      if (jenis === "amount_no_decimals") return rapi(v, 0, ",", ".");
      if (jenis === "amount_with_comma_separator") return rapi(v, 2, ".", ",");
      if (jenis === "amount_no_decimals_with_comma_separator") return rapi(v, 0, ".", ",");
      return rapi(v, 2, ",", ".");
    });
  }

  var hargaVarian = 0;

  function kotakTambahan() {
    return $$("[data-tambahan]").filter(function (k) { return k.checked; });
  }

  function hitungSubtotal() {
    var baris = $("#jeyaSub");
    if (!baris) return;
    var dipilih = kotakTambahan();
    var tambahan = dipilih.reduce(function (jml, k) {
      return jml + (Number(k.getAttribute("data-harga")) || 0);
    }, 0);
    if (!dipilih.length) { baris.hidden = true; return; }
    var qty = Number(($("#jeyaQty") || {}).value || 1) || 1;
    var nilai = $("#jeyaSubVal");
    if (nilai) nilai.textContent = uang((hargaVarian + tambahan) * qty);
    baris.hidden = false;
  }

  function galat(r) {
    return r.json().then(function (d) {
      throw new Error(d.description || d.message || "Sorry, we could not update your basket.");
    });
  }

  function tambah(payload, namaProduk) {
    if (sedangKirim) return;
    sedangKirim = true;
    fetch(R.cartAdd, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.ok ? r.json() : galat(r); })
      .then(function (res) {
        var pertama = res && res.items ? res.items[0] : res;
        var nama = namaProduk || (pertama && pertama.product_title) || "Item";
        return segarkanKeranjang(true).then(function () {
          toast(nama + " added to your basket");
        });
      })
      .catch(function (e) { toast(e.message); })
      .then(function () { sedangKirim = false; });
  }

  /* Satu baris pasta dan bahan-bahannya adalah satu barang di mata pelanggan.
     Menghapus pastanya harus ikut menghapus bawangnya, dan menaikkan jumlahnya
     harus menaikkan keduanya — kalau tidak, orang membayar bawang untuk pasta
     yang sudah tidak ada. Semua kunci barisnya dikirim dalam satu permintaan. */
  function ubahGrup(kunciSemua, qty) {
    if (sedangKirim) return;
    sedangKirim = true;
    var isi = {};
    kunciSemua.forEach(function (k) { isi[k] = qty; });
    fetch(R.cartUpdate || "/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: isi })
    })
      .then(function (r) { return r.ok ? r.json() : galat(r); })
      .then(function () {
        return segarkanKeranjang(false).then(function () {
          if (document.body.classList.contains("template-cart")) window.location.reload();
        });
      })
      .catch(function (e) { toast(e.message); })
      .then(function () { sedangKirim = false; });
  }

  function ubahBaris(key, qty) {
    if (sedangKirim) return;
    sedangKirim = true;
    fetch(R.cartChange, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.ok ? r.json() : galat(r); })
      .then(function () {
        return segarkanKeranjang(false).then(function () {
          /* halaman keranjang penuh perlu digambar ulang seluruhnya */
          if (document.body.classList.contains("template-cart")) window.location.reload();
        });
      })
      .catch(function (e) { toast(e.message); })
      .then(function () { sedangKirim = false; });
  }

  /* ---------------------------------------------------------------- klik global */
  document.addEventListener("click", function (e) {
    var t = e.target, el;

    el = t.closest("#openCart");
    if (el) { e.preventDefault(); openPanel($("#cart")); return; }

    el = t.closest("#openNav");
    if (el) { e.preventDefault(); openPanel($("#mnav")); return; }

    el = t.closest("#openSearch");
    if (el) {
      e.preventDefault();
      var ov = $("#searchOv");
      if (ov) {
        lastFocus = document.activeElement;
        ov.classList.add("open");
        ov.setAttribute("aria-hidden", "false");
        lock(true);
        var inp = $("#searchInput");
        if (inp) { inp.focus(); inp.select(); }
        saran(inp ? inp.value : "");
      }
      return;
    }

    if (t.closest("[data-close]") || t.closest("#scrim") || t.closest("#closeFilters")) { e.preventDefault(); closeAll(); return; }

    el = t.closest("[data-add]");
    if (el) {
      e.preventDefault();
      tambah({ items: [{ id: Number(el.getAttribute("data-add")), quantity: 1 }] },
             el.getAttribute("data-name"));
      return;
    }

    el = t.closest("[data-q]");
    if (el && el.getAttribute("data-key")) {
      e.preventDefault();
      var baris = el.parentNode.querySelector("span");
      var q = parseInt(baris ? baris.textContent : "1", 10) || 1;
      var tujuan = q + Number(el.getAttribute("data-q"));
      var grup = el.getAttribute("data-grup");
      if (grup) ubahGrup(grup.split(","), tujuan);
      else ubahBaris(el.getAttribute("data-key"), tujuan);
      return;
    }

    el = t.closest("[data-del]");
    if (el) {
      e.preventDefault();
      var grupHapus = el.getAttribute("data-grup");
      if (grupHapus) ubahGrup(grupHapus.split(","), 0);
      else ubahBaris(el.getAttribute("data-del"), 0);
      return;
    }

    /* akordion menu layar kecil */
    el = t.closest(".macc > button");
    if (el) {
      e.preventDefault();
      el.parentNode.classList.toggle("open");
      return;
    }

    /* kelompok filter buka-tutup */
    el = t.closest(".f-group > button");
    if (el) {
      e.preventDefault();
      var grup = el.parentNode;
      var tutup = grup.classList.toggle("closed");
      el.setAttribute("aria-expanded", tutup ? "false" : "true");
      return;
    }

    el = t.closest("#openFilters");
    if (el) {
      e.preventDefault();
      var f = $("#filters");
      if (f) {
        lastFocus = document.activeElement;
        f.classList.add("open");
        var scrim2 = $("#scrim");
        if (scrim2) scrim2.classList.add("on");
        lock(true);
        var tutupBtn = $("#closeFilters");
        if (tutupBtn) tutupBtn.focus();
      }
      return;
    }

    /* tampilan kisi / daftar */
    el = t.closest("#layGrid, #layList");
    if (el) {
      e.preventDefault();
      var daftar = el.id === "layList";
      var kisi = $("#shopGrid");
      if (kisi) kisi.classList.toggle("is-list", daftar);
      var g = $("#layGrid"), l = $("#layList");
      if (g) g.setAttribute("aria-pressed", String(!daftar));
      if (l) l.setAttribute("aria-pressed", String(daftar));
      try { localStorage.setItem("jeyaLayout", daftar ? "list" : "grid"); } catch (err) {}
      return;
    }

    /* pilihan varian di halaman produk */
    el = t.closest(".opt[data-option]");
    if (el) { e.preventDefault(); pilihOpsi(el); return; }

    /* jumlah di halaman produk */
    el = t.closest("[data-mq]");
    if (el) {
      e.preventDefault();
      var kotak = $("#mQty"), hidden = $("#jeyaQty");
      if (!kotak) return;
      var n = Math.max(1, (parseInt(kotak.textContent, 10) || 1) + Number(el.getAttribute("data-mq")));
      kotak.textContent = n;
      if (hidden) hidden.value = n;
      var kurang = $('[data-mq="-1"]');
      if (kurang) kurang.disabled = n <= 1;
      /* Subtotal per barang ikut jumlah: tanpa ini ia tetap memperlihatkan harga
         untuk satu buah padahal keranjang akan menerima dua. */
      hitungSubtotal();
      return;
    }

    /* gambar kecil di halaman produk */
    el = t.closest(".thumb[data-img]");
    if (el) {
      e.preventDefault();
      var utama = $(".modal-art img");
      if (utama) {
        utama.removeAttribute("srcset");
        utama.src = el.getAttribute("data-img");
      }
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAll();
    trapFocus(e);
  });

  /* ---------------------------------------------------------------- halaman produk */
  function pilihOpsi(tombol) {
    var idx = Number(tombol.getAttribute("data-option"));
    $$('.opt[data-option="' + idx + '"]').forEach(function (b) {
      b.setAttribute("aria-pressed", String(b === tombol));
    });

    var simpul = $("#jeyaVariants");
    if (!simpul) return;
    var varian;
    try { varian = JSON.parse(simpul.textContent); } catch (err) { return; }

    var dipilih = $$(".opt-row").map(function (row) {
      var aktif = row.querySelector('.opt[aria-pressed="true"]');
      return aktif ? aktif.getAttribute("data-value") : null;
    });

    var cocok = varian.filter(function (v) {
      return dipilih.every(function (nilai, i) { return nilai === null || v.options[i] === nilai; });
    })[0];
    if (!cocok) return;

    var id = $("#jeyaVariantId");
    if (id) id.value = cocok.id;

    var harga = $("#mPrice");
    if (harga && cocok.price_formatted) harga.textContent = cocok.price_formatted;
    if (typeof cocok.price === "number") { hargaVarian = cocok.price; hitungSubtotal(); }

    /* jaga alamat halaman tetap menunjuk varian yang dilihat, supaya bisa dibagikan */
    if (window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set("variant", cocok.id);
      window.history.replaceState({}, "", u);
    }

    var tombolBeli = $('#jeyaProductForm button[type="submit"]');
    if (tombolBeli) {
      tombolBeli.disabled = !cocok.available;
      tombolBeli.innerHTML = cocok.available
        ? '<svg class="ic"><use href="#i-cart"/></svg> Add to cart'
        : "Sold out";
    }
  }

  /* Nilai awal subtotal: varian yang sedang terpilih saat halaman dibuka. */
  (function () {
    var simpul = $("#jeyaVariants");
    var kolom = $("#jeyaVariantId");
    if (!simpul || !kolom) return;
    var daftar;
    try { daftar = JSON.parse(simpul.textContent); } catch (err) { return; }
    var id = Number(kolom.value);
    daftar.forEach(function (v) { if (v.id === id) hargaVarian = v.price || 0; });
    hitungSubtotal();
  })();

  /* Bahan yang sama tidak boleh ditambah sekaligus dibuang ("+ Candlenut" dan
     "Remove: Candlenuts"). Nama dibandingkan setelah dirapikan: huruf kecil,
     tanpa spasi/tanda baca, tanpa akhiran s/e — jadi tunggal dan jamak dianggap
     sama. Pasangan di seberang dinonaktifkan, bukan dicabut diam-diam. */
  function kunciBahan(s) {
    return String(s || "").toLowerCase()
      .replace(/\b(extra|add|more|less|no|remove|without)\b/g, "")
      .replace(/[^a-z]/g, "").replace(/s$/, "").replace(/e$/, "");
  }

  function kotakBuang() {
    var wadah = $("#jeyaProductForm") || document;
    return $$(".opt-checks input[type=checkbox]:not([data-tambahan])", wadah);
  }

  function jagaBentrok() {
    var tambah = $$("[data-tambahan]");
    var buang = kotakBuang();
    if (!tambah.length || !buang.length) return;
    var kunciTambah = {}, kunciBuang = {};
    tambah.forEach(function (k) { if (k.checked) kunciTambah[kunciBahan(k.getAttribute("data-nama"))] = 1; });
    buang.forEach(function (k) { if (k.checked) kunciBuang[kunciBahan(k.value)] = 1; });
    var ada = false;
    function atur(k, kunci, lawan, pesan) {
      var kena = !k.checked && !!lawan[kunci];
      k.disabled = kena;
      var lbl = k.closest("label");
      if (lbl) lbl.title = kena ? pesan : "";
      if (kena) ada = true;
    }
    tambah.forEach(function (k) {
      atur(k, kunciBahan(k.getAttribute("data-nama")), kunciBuang, "You chose to remove this ingredient");
    });
    buang.forEach(function (k) {
      atur(k, kunciBahan(k.value), kunciTambah, "You added extra of this ingredient");
    });
    var catatan = $("#jeyaClash");
    var blok = $("[data-addons]");
    if (!catatan && blok) {
      catatan = document.createElement("p");
      catatan.id = "jeyaClash";
      catatan.className = "opt-clash";
      catatan.textContent = "An ingredient can't be added and removed at the same time.";
      blok.appendChild(catatan);
    }
    if (catatan) catatan.hidden = !ada;
  }
  jagaBentrok();

  document.addEventListener("change", function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-tambahan")) {
      hitungSubtotal();
    }
    if (e.target && e.target.type === "checkbox" && e.target.closest && e.target.closest(".opt-checks")) {
      jagaBentrok();
    }
  });

  var formProduk = $("#jeyaProductForm");
  if (formProduk) {
    formProduk.addEventListener("submit", function (e) {
      e.preventDefault();
      var data = new FormData(formProduk);
      var jumlah = Number(data.get("quantity") || 1) || 1;
      var utama = { id: Number(data.get("id")), quantity: jumlah, properties: {} };
      data.forEach(function (nilai, kunci) {
        var m = kunci.match(/^properties\[(.+)\]$/);
        if (!m || !String(nilai).trim()) return;
        /* Beberapa kotak centang memakai nama yang sama — Shopify hanya menyimpan
           satu nilai per nama, jadi digabung jadi satu catatan dipisah koma. */
        var ada = utama.properties[m[1]];
        utama.properties[m[1]] = ada ? ada + ", " + nilai : nilai;
      });

      /* Penjaga terakhir kalau kotak dicentang lewat jalan lain (mis. tombol kembali
         peramban memulihkan centang lama setelah halaman dimuat). */
      var dibuang = {};
      kotakBuang().forEach(function (k) { if (k.checked) dibuang[kunciBahan(k.value)] = 1; });
      var bentrok = kotakTambahan().filter(function (k) {
        return dibuang[kunciBahan(k.getAttribute("data-nama"))];
      });
      if (bentrok.length) {
        jagaBentrok();
        toast("You can't add and remove " + bentrok[0].getAttribute("data-nama") + " at the same time.");
        return;
      }

      var muatan = { items: [utama] };

      /* Bahan berbayar dikirim sebagai baris tersendiri: itu satu-satunya cara
         Shopify menagih uang tambahan tanpa aplikasi. Semuanya diikat satu
         penanda grup, dan penanda berawalan garis bawah tidak diperlihatkan
         Shopify kepada pelanggan. */
      var dipilih = kotakTambahan();
      if (dipilih.length) {
        var grup = "jg" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
        utama.properties._jeya_group = grup;
        utama.properties.Extras = dipilih.map(function (k) {
          return k.getAttribute("data-nama");
        }).join(", ");
        dipilih.forEach(function (k) {
          muatan.items.push({
            id: Number(k.getAttribute("data-tambahan")),
            quantity: jumlah,
            properties: { _jeya_group: grup, _jeya_child: "1" }
          });
        });
      }

      var judul = document.querySelector(".modal-info h1");
      tambah(muatan, judul ? judul.textContent.trim() : null);
    });
  }

  /* ---------------------------------------------------------------- filter & urutan */
  var formFilter = $("#jeyaFilterForm");
  if (formFilter) {
    formFilter.addEventListener("change", function () {
      var q = [];
      $$("input[type=checkbox]:checked", formFilter).forEach(function (c) {
        q.push(encodeURIComponent(c.name) + "=" + encodeURIComponent(c.value));
      });
      var urut = $("#sortBy");
      if (urut && urut.value) q.push("sort_by=" + encodeURIComponent(urut.value));
      window.location.search = q.join("&");
    });
  }

  var urutan = $("#sortBy");
  if (urutan) {
    urutan.addEventListener("change", function () {
      var u = new URL(window.location.href);
      u.searchParams.set("sort_by", urutan.value);
      window.location.href = u.toString();
    });
  }

  (function () {
    var kisi = $("#shopGrid");
    if (!kisi) return;
    var simpan;
    try { simpan = localStorage.getItem("jeyaLayout"); } catch (e) { return; }
    if (simpan !== "list") return;
    kisi.classList.add("is-list");
    var g = $("#layGrid"), l = $("#layList");
    if (g) g.setAttribute("aria-pressed", "false");
    if (l) l.setAttribute("aria-pressed", "true");
  })();

  /* ---------------------------------------------------------------- pencarian */
  var tundaan = null;

  function saran(q) {
    var kotak = $("#sRes"), hint = $("#sHint");
    if (!kotak) return;
    if (!q || q.length < 2) {
      kotak.innerHTML = "";
      if (hint) hint.textContent = "Popular right now";
      return;
    }
    var url = (R.predictive || "/search/suggest") +
      "?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=5&section_id=predictive-search";
    fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var isi = doc.querySelector("#sResInner");
        if (!isi) return;
        var pesan = isi.querySelector(".s-hint-value");
        if (hint && pesan) hint.textContent = pesan.textContent.trim();
        if (pesan) pesan.remove();
        kotak.innerHTML = isi.innerHTML;
      })
      .catch(function () { /* form tetap bisa dikirim ke /search */ });
  }

  var kotakCari = $("#searchInput");
  if (kotakCari) {
    kotakCari.addEventListener("input", function () {
      clearTimeout(tundaan);
      var v = this.value;
      tundaan = setTimeout(function () { saran(v); }, 250);
    });
  }

  /* ---------------------------------------------------------------- baris produk */
  var rail = $("#rail");
  if (rail) {
    var nav = document.querySelector(".rail-nav");
    var prev = $("#railPrev"), next = $("#railNext");

    function geser(arah) {
      var kartu = rail.querySelector(".p-card");
      var lebar = kartu ? kartu.getBoundingClientRect().width + 18 : 300;
      rail.scrollBy({ left: arah * lebar * 2, behavior: "smooth" });
    }

    /* Panah hanya berguna kalau barisnya memang lebih panjang daripada layarnya.
       Pada lima kartu di layar lebar, semuanya muat sekaligus — menekan panah tidak
       akan menggeser apa pun. Daripada membiarkan tombol yang diam saja, panahnya
       disembunyikan, dan muncul lagi begitu barisnya benar-benar bisa digeser. */
    function perbaruiPanah() {
      var bisa = rail.scrollWidth > rail.clientWidth + 4;
      if (nav) nav.classList.toggle("mati", !bisa);
      if (!bisa) return;
      var kiri = rail.scrollLeft;
      var mentok = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = kiri <= 2;
      if (next) next.disabled = kiri >= mentok;
    }

    if (prev) prev.addEventListener("click", function () { geser(-1); });
    if (next) next.addEventListener("click", function () { geser(1); });
    rail.addEventListener("scroll", perbaruiPanah, { passive: true });
    window.addEventListener("resize", perbaruiPanah);
    perbaruiPanah();
  }

  /* ---------------------------------------------------------------- carousel rebrand */
  /* Dipakai "This season's highlights" dan "Reviews". Bisa lebih dari satu di satu
     halaman, jadi diikat lewat atribut data-geser, bukan id seperti #rail lama.
     Geserannya sendiri scroll-snap CSS; skrip ini hanya tombol panahnya, jadi
     tanpa skrip deretannya tetap bisa digeser jari atau trackpad. */
  function pasangGeser(akar) {
    $$("[data-geser]", akar || document).forEach(function (box) {
      if (box.getAttribute("data-geser-siap")) return;
      box.setAttribute("data-geser-siap", "1");
      var trek = box.querySelector("[data-geser-track]");
      var kiri = box.querySelector("[data-geser-prev]");
      var kanan = box.querySelector("[data-geser-next]");
      var navi = box.querySelector(".jc-nav");
      if (!trek) return;
      function langkah(arah) {
        var anak = trek.firstElementChild;
        var lebar = anak ? anak.getBoundingClientRect().width : trek.clientWidth / 2;
        var muat = Math.max(1, Math.floor((trek.clientWidth + 4) / (lebar + 4)));
        trek.scrollBy({ left: arah * muat * (lebar + parseFloat(getComputedStyle(trek).columnGap || 14)), behavior: "smooth" });
      }
      function segarkan() {
        var bisa = trek.scrollWidth > trek.clientWidth + 4;
        if (navi) navi.classList.toggle("mati", !bisa);
        if (kiri) kiri.disabled = trek.scrollLeft <= 2;
        if (kanan) kanan.disabled = trek.scrollLeft >= trek.scrollWidth - trek.clientWidth - 2;
      }
      if (kiri) kiri.addEventListener("click", function () { langkah(-1); });
      if (kanan) kanan.addEventListener("click", function () { langkah(1); });
      trek.addEventListener("scroll", segarkan, { passive: true });
      window.addEventListener("resize", segarkan);
      segarkan();
    });
  }
  pasangGeser();
  document.addEventListener("shopify:section:load", function (e) { pasangGeser(e.target); });

  /* ---------------------------------------------------------------- header & pita */
  var hdr = $("#hdr");
  if (hdr) {
    window.addEventListener("scroll", function () {
      hdr.classList.toggle("scrolled", window.scrollY > 8);
    }, { passive: true });
  }

  (function () {
    var simpul = $("#jeyaAnnounce"), box = $("#announce"), bar = document.querySelector(".announce");
    if (!simpul || !box || !bar) return;
    var pesan;
    try { pesan = JSON.parse(simpul.textContent); } catch (e) { return; }
    if (!pesan || pesan.length < 2) return;

    var i = 0, tahan = false;
    /* berhenti berputar selama ada yang membaca atau menyusuri dengan Tab */
    bar.addEventListener("mouseenter", function () { tahan = true; });
    bar.addEventListener("mouseleave", function () { tahan = false; });
    bar.addEventListener("focusin", function () { tahan = true; });
    bar.addEventListener("focusout", function () { tahan = false; });

    setInterval(function () {
      if (document.hidden || tahan) return;
      box.classList.add("out");
      setTimeout(function () {
        i = (i + 1) % pesan.length;
        box.innerHTML = '<svg class="ic"><use href="#' + pesan[i].icon + '"/></svg><span></span>';
        box.lastChild.textContent = pesan[i].text;
        box.classList.remove("out");
      }, 360);
    }, 5200);
  })();

  /* ---------------------------------------------------------------- muncul saat digulir */
  /* .rv disembunyikan lewat CSS (opacity:0) dan baru terlihat setelah kelas .in
     dipasang di sini. Bahayanya: kalau ada bagian halaman yang digambar ULANG
     setelah berkas ini berjalan, simpul barunya tidak pernah diamati siapa pun
     dan bagian itu tinggal kosong selamanya. Persis itu yang terjadi di editor
     tema: menambah atau mengubah satu section membuat Shopify menggambar ulang
     section tersebut, dan hasilnya section baru tampak putih kosong.
     Karena itu pengamatannya bisa dipanggil ulang, dan dipanggil ulang setiap
     kali Shopify memberi tahu ada section yang dimuat. */
  var pasangMuncul = (function () {
    var io = null;
    var bisa = ("IntersectionObserver" in window) &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (bisa) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    }
    return function (akar, langsung) {
      var daftar = $$(".rv", akar || document);
      if (akar && akar.classList && akar.classList.contains("rv")) daftar.push(akar);
      daftar.forEach(function (e) {
        if (e.classList.contains("in")) return;
        /* langsung = tampilkan sekarang juga, tanpa menunggu digulir. Dipakai
           untuk bagian yang baru digambar ulang: di sana yang penting terlihat,
           bukan animasinya, dan menunggu pengamat gulir hanya menambah satu cara
           lagi untuk berakhir kosong. */
        if (io && !langsung) io.observe(e); else e.classList.add("in");
      });
    };
  })();
  pasangMuncul();

  /* Editor tema menggambar ulang satu section setiap kali setelannya diubah,
     dan simpul barunya tidak pernah diamati oleh pengamat yang sudah berjalan.
     Tanpa baris ini, section yang baru ditambahkan tampak putih kosong. */
  document.addEventListener("shopify:section:load", function (e) {
    pasangMuncul(e.target || document, true);
  });
  document.addEventListener("shopify:section:select", function (e) {
    pasangMuncul(e.target || document, true);
  });

  /* Jaring pengaman terakhir. Menyembunyikan isi halaman di balik JavaScript
     berarti setiap alasan pengamat gulir tidak berjalan — peramban tua, tab
     latar, halaman yang digambar ulang oleh pihak lain — berakhir sebagai
     halaman kosong tanpa pesan galat. Setelah beberapa detik, apa pun yang
     masih tersembunyi ditampilkan begitu saja. Animasinya tetap utuh untuk
     pemakaian normal, karena pengamat hampir selalu menang duluan. */
  setTimeout(function () { pasangMuncul(document, true); }, 3000);
})();
